import { render, staticRenderFns } from "./show.vue?vue&type=template&id=d663d07c&scoped=true&"
import script from "./show.vue?vue&type=script&lang=coffee&"
export * from "./show.vue?vue&type=script&lang=coffee&"
import style0 from "./show.vue?vue&type=style&index=0&id=d663d07c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d663d07c",
  null
  
)

export default component.exports